/**
 * Routes.
 * @module routes
 */

import App from '@plone/volto/components/theme/App/App';
import { defaultRoutes } from '@plone/volto/routes';
import Move from '@package/components/manage/Move/Move';
import config from '@plone/volto/registry';

/**
 * Routes array.
 * @array
 * @returns {array} Routes.
 */

const routes = [
  ...(config.settings.addonMainRoutes || []),
  {
    path: '/',
    component: App, // Change this if you want a different component
    routes: [
      {
        path: '/**/move',
        component: Move,
      },
      ...(config.addonRoutes || []),
      ...defaultRoutes,
    ],
  },
];

export default routes;
